import type { AuthPermissionUser } from '../../services/authPermissions';

const WAREHOUSE_DOCUMENT_MANAGEMENT_ROLES = ['ADMIN', 'OPERATIONS'];
const WAREHOUSE_DOCUMENT_DELETION_ROLES = ['ADMIN', 'OPERATIONS'];

export function canManageWZDocuments(user: AuthPermissionUser | null | undefined): boolean {
  return WAREHOUSE_DOCUMENT_MANAGEMENT_ROLES.includes(user?.role || '');
}

export function canManagePZDocuments(user: AuthPermissionUser | null | undefined): boolean {
  return WAREHOUSE_DOCUMENT_MANAGEMENT_ROLES.includes(user?.role || '');
}

export function canDeleteWarehouseDocument(user: AuthPermissionUser | null | undefined): boolean {
  return WAREHOUSE_DOCUMENT_DELETION_ROLES.includes(user?.role || '');
}
